/**
 * Stable identifier persisted for the experimental div-based table layout.
 */
export const TABLE_V2_LAYOUT_ID = 'table-v2' as const;
